import { Suspense, useState } from 'react'
import { useTranslation } from 'react-i18next'
import { InView } from 'react-intersection-observer'
import Container from '../Container/Container'
import styles from './Social.module.scss'
import SocialItem from './SocialItem'

const Social = () => {
	const { t } = useTranslation()

	const [show, setShow] = useState(false)

	const onShow = (inView: boolean, entry: IntersectionObserverEntry) => {
		if (!show && inView) {
			setShow(true)
		}
	}

	return (
		<Suspense>
			<InView onChange={onShow} className={styles.wrapper}>
				{show && (
					<Container>
						<div className={styles.body}>
							<SocialItem
								iconName='message-circle'
								color='blue'
								link={{
									src: 'https://t.me/SAIRUS_ChatGPT_bot',
									text: 'Sairus GPT',
								}}
								headerTitle={{
									text: t('landing.social.telegram.headerTitle.text'),
									gradientText: t(
										'landing.social.telegram.headerTitle.gradientText'
									),
									underlineText:
										t('landing.social.telegram.headerTitle.underlineText') ||
										'',
								}}
								headerText={t('landing.social.telegram.headerText')}
								bodyTitle={t('landing.social.telegram.bodyTitle')}
								bodyText={t('landing.social.telegram.bodyText')}
							/>

							<SocialItem
								iconName='brain-network'
								color='magenta'
								headerTitle={{
									text: t('landing.social.socialNetwork.headerTitle.text'),
									gradientText: t(
										'landing.social.socialNetwork.headerTitle.gradientText'
									),
								}}
								headerText={t('landing.social.socialNetwork.headerText')}
								bodyTitle={t('landing.social.socialNetwork.bodyTitle')}
								bodyText={t('landing.social.socialNetwork.bodyText')}
							/>
						</div>
					</Container>
				)}
			</InView>
		</Suspense>
	)
}

export default Social
